/**
 * The look of a control sitting on the navigation chrome (the top bar): a fine
 * white outline on a faint fill, brightening on hover, focus and while open.
 * One definition, so the menu button, the bell and the profile menu match.
 */
export const CHROME_CONTROL_CLASS =
  'border border-white/25 bg-white/[0.04] text-white transition-colors duration-150 ' +
  'hover:border-white/50 hover:bg-white/10 data-[open]:border-white/50 data-[open]:bg-white/10 ' +
  'focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-offset-2 ' +
  'focus-visible:ring-offset-chrome-700';
